import { create } from 'apisauce';
import { getQueryString } from '../functions';
import { getCookies, removeCookies } from '../store/useCookies';
import { env } from '../utils/env/config';
import { navigateTo } from '../utils/navigation';
import { ROUTES_PATH } from '../resources/routes-name';
import { openAlert } from '../components/alert/hooks';
export const ip = 'http://192.168.1.169:2000';

export const MODE_API = {
  DEVELOPMENT: env.url_dev,
  UAT: env.url_uat,
  PRODUCTION: env.url_prd,
};
// export const CONNECT_API = 'https://jsonplaceholder.typicode.com';
export const CONNECT_API = MODE_API[`${env.node_env}`.toUpperCase()];
const api = create({
  baseURL: CONNECT_API,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
  timeout: 50000, // 50 seconds
});

api.axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.code === 'ECONNABORTED') {
      navigateTo({ pathname: ROUTES_PATH.ROUTE_LOGIN_EMPLOYEE.PATH });
    }
    return Promise.reject(error);
  },
);

const apiupload = create({
  baseURL: CONNECT_API,
  withCredentials: true,
  headers: {
    'Content-Type': 'multipart/form-data',
  },
});
/**
 * ฟังก์ชั่นสำหรับ ยิงข้อมูล
 * @param {string} path
 * @param {{}} obj
 * @return {{}}
 */

export const POST = (path, obj, token = getCookies('accessToken')) =>
  new Promise((resolve, reject) => {
    api
      .post(path, obj, {
        headers: {
          Authorization: 'Bearer ' + token,
        },
      })
      .then((response) => {
        if (response.status === 200) {
          resolve(response.data);
        } else {
          if (response.status === 401) {
            removeCookies('accessToken');
            localStorage.removeItem('refreshed');
            localStorage.removeItem('branchId');
            openAlert({
              type: 'error',
              message: 'หมดอายุการใช้งาน กรุณา Login อีกครั้ง',
              model: 'message',
            });
            setTimeout(() => {
              window.location.href = ROUTES_PATH.ROUTE_LOGIN_EMPLOYEE.PATH;
            }, 500);
          } else {
            response.data
              ? reject(response.data)
              : reject({ success: false, message: response.problem });
          }
        }
      })
      .catch((err) => {
        if (err && err.response && err.response.status === 401) {
          navigateTo({ pathname: ROUTES_PATH.ROUTE_LOGIN_EMPLOYEE.PATH });
          return;
        }
        reject(err);
      });
  });

/**
 * ฟังก์ชั่นสำหรับ ยิงข้อมูล
 * @param {string} path
 * @param {{}} obj
 * @return {{}}
 */
export const PUT = (path, obj, token = getCookies('accessToken')) =>
  new Promise((resolve, reject) => {
    api
      .put(path, obj, {
        headers: {
          Authorization: 'Bearer ' + token,
        },
      })
      .then((response) => {
        if (response.status === 200) {
          resolve(response.data);
        } else {
          if (response.status === 401) {
            removeCookies('accessToken');
            localStorage.removeItem('refreshed');
            localStorage.removeItem('branchId');
            openAlert({
              type: 'error',
              message: 'หมดอายุการใช้งาน กรุณา Login อีกครั้ง',
              model: 'message',
            });
            setTimeout(() => {
              window.location.href = ROUTES_PATH.ROUTE_LOGIN_EMPLOYEE.PATH;
            }, 500);
          } else {
            response.data
              ? reject(response.data)
              : reject({ success: false, message: response.problem });
          }
        }
      })
      .catch((err) => {
        if (err && err.response && err.response.status === 401) {
          navigateTo({ pathname: ROUTES_PATH.ROUTE_LOGIN_EMPLOYEE.PATH });
          return;
        }
        reject(err);
      });
  });

/**
 * ฟังก์ชั่นสำหรับ ดึงข้อมูล
 * @param {string} path
 *
 */
export const GET = (path, token = getCookies('accessToken')) =>
  new Promise((resolve, reject) => {
    api
      .get(
        path,
        {},
        {
          headers: {
            Authorization: 'Bearer ' + token,
          },
        },
      )
      .then((response) => {
        if (response.status === 200) {
          resolve(response.data);
        } else {
          if (response.status === 401) {
            removeCookies('accessToken');
            localStorage.removeItem('refreshed');
            localStorage.removeItem('branchId');
            openAlert({
              type: 'error',
              message: 'หมดอายุการใช้งาน กรุณา Login อีกครั้ง',
              model: 'message',
            });
            setTimeout(() => {
              window.location.href = ROUTES_PATH.ROUTE_LOGIN_EMPLOYEE.PATH;
            }, 500);
          } else {
            response.data
              ? reject(response.data)
              : reject({ success: false, message: response.problem });
          }
        }
      })
      .catch((err) => {
        if (err && err.response && err.response.status === 401) {
          navigateTo({ pathname: ROUTES_PATH.ROUTE_LOGIN_EMPLOYEE.PATH });
          return;
        }
        reject(err);
      });
  });

export const UPLOAD = (path, formdata, token = getCookies('accessToken')) =>
  new Promise((resolve, reject) => {
    apiupload
      .post(path, formdata, {
        headers: {
          Authorization: 'Bearer ' + token,
        },
      })
      .then((response) => {
        if (response.status === 200) {
          resolve(response.data);
        } else {
          if (response.status === 401) {
            removeCookies('accessToken');
            localStorage.removeItem('refreshed');
            localStorage.removeItem('branchId');
            openAlert({
              type: 'error',
              message: 'หมดอายุการใช้งาน กรุณา Login อีกครั้ง',
              model: 'message',
            });
            setTimeout(() => {
              window.location.href = ROUTES_PATH.ROUTE_LOGIN_EMPLOYEE.PATH;
            }, 500);
          } else {
            response.data
              ? reject(response.data)
              : reject({ success: false, message: response.problem });
          }
        }
      })
      .catch((err) => {
        if (err && err.response && err.response.status === 401) {
          navigateTo({ pathname: ROUTES_PATH.ROUTE_LOGIN_EMPLOYEE.PATH });
          return;
        }
        reject(err);
      });
  });

/* ################################################## URL ################################################## */
export const LOGIN = `/authen/login`;
export const LOGIN_GOOGLE = `/authen/login-google`;
export const REGISTER = `/authen/register`;
export const GET_PROFILE = `/authen/get_profile`;
export const GET_ALL_PRODUCT = `/product/get-all`;
export const GET_PRODUCT_SEARCH = (obj) => `/product/search?${getQueryString(obj)}`;

export const GET_ALL_POST = `/posts`;
export const INSERT_POST = `/posts`;
export const UPDATE_POST = (id) => `/posts/${id}`;
export const GET_POST_BY_ID = (id) => `/posts/${id}`;

export const GET_ME = (lineUid, branchId) =>
  `/incentive/api/customer/incentive/me/lineuid/${lineUid}?branchId=${branchId}`;
export const POST_CHECK_EMPLOYEE = () => `/incentive/api/customer/incentive/check-employee`;
export const POST_LOGIN_EMPLOYEE = () => `/incentive/api/customer/incentive/login`;
export const POST_SUBMIT_INCENTIVE = () => `/incentive/api/customer/incentive/submit-barcode`;
export const GET_INCENTIVE_HISTORY = (employeeId) =>
  `/incentive/api/customer/incentive/scan-history/${employeeId}`;
export const POST_LOGOUT = () => `/incentive/api/customer/incentive/logout`;
export const POST_CHECK_BARCODE = () => `/incentive/api/customer/incentive/check-barcode`;
export const POST_SCAN_BARCODE_IMAGE = () => `/incentive/api/customer/incentive/scan-barcode-image`;
export const POST_BRANCH = () => `/incentive/api/customer/incentive/branch-options`;
